
export const CATEGORY = "CATEGORY"
export const PROFILE_CATEGORY = "PROFILE_CATEGORY"
export const ADD_CATEGORY = "ADD_CATEGORY"

export const SERVICES = "SERVICES"

export const COMPANYPROFILESETUP = "COMPANYPROFILESETUP"
export const UPDATECOMPANYPROFILE = "UPDATECOMPANYPROFILE"

export const GETPROFILESETUP = "GETPROFILESETUP"


export const PROFILEDETAIL = "PROFILEDETAIL"
export const UPDATEPROFILE = "UPDATEPROFILE"
export const RESUBMITPROFILE = "RESUBMITPROFILE"

export const DETAILPROFILE = "DETAILPROFILE"
export const REMOVEPROFILEIMAGE = "REMOVEPROFILEIMAGE"
export const HOME_PAGE_GET_CATEGORY = "HOME_PAGE_GET_CATEGORY"